import $ from 'jquery';
import AbstractForm from './abstract-form.js';
import InfoForm from './blocks/insertInfoBlock.js';
import Loader from './blocks/loaderBlock.js';
import RequestSuccess from './blocks/requestSuccessBlock.js';
import RequestError from './blocks/requestErrorBlock.js';
import RequestBlock from './blocks/requestBlock.js';
import MapBlock from './blocks/mapBlock.js';
import config from './config.js';
import router from 'lib/router.js';
import CSRF from 'lib/csrf.js';

export default class CreateObjectForm extends AbstractForm {
    constructor() {
        super();

        const hash = router.getHashName();
        let activeBlock = 'infoForm';

        router.removeHash();
        if (hash === 'request') {
            activeBlock = 'request';
        }

        this.addBlock(
            'infoForm',
            new InfoForm(
                {
                    parent: this.element,
                    shown: activeBlock === 'infoForm',
                },
                {
                    confirm: ::this.onInfoEntered,
                    houseNotFound: () => {
                        const { request } = this.blocks;

                        request.drop();
                        this.showRequest();
                    },
                }
            )
        )
            .addBlock('loader', new Loader({}, {}))
            .addBlock(
                'map',
                new MapBlock(
                    {},
                    {
                        confirm: (result = {}) => {
                            this.save({
                                houseId: result.extra.house_id,
                            });
                        },
                        cancel: () => {
                            if (this.isLoading) {
                                console.warn(
                                    'Cant cancel create step on loading'
                                );
                                return;
                            }
                            this.showInfoForm();
                        },
                    }
                )
            )
            .addBlock(
                'request',
                new RequestBlock(
                    {
                        shown: activeBlock === 'request',
                    },
                    {
                        complete: ::this.showRequestSuccess,
                        error: ::this.showRequestError,
                        cancel: ::this.showInfoForm,
                    }
                )
            )
            .addBlock(
                'requestSuccess',
                new RequestSuccess(
                    {},
                    {
                        resend: () => {
                            const { request } = this.blocks;

                            request.drop();
                            this.showRequest();
                        },
                        cancel: ::this.showInfoForm,
                    }
                )
            )
            .addBlock(
                'requestError',
                new RequestError(
                    {},
                    {
                        resend: ::this.showRequest,
                        cancel: ::this.showInfoForm,
                    }
                )
            );
    }

    /**
     * Отобразить блок с отправкой заявки
     */
    showRequest() {
        this.showBlock('request');
    }

    /**
     * Отобразить блок что успешно отправлен запрос
     */
    showRequestSuccess() {
        this.showBlock('requestSuccess');
    }

    /**
     * Отобразить ошибку при отправке запроса
     */
    showRequestError() {
        this.showBlock('requestError');
    }

    /**
     * Отобразить блок ввода данных
     */
    showInfoForm() {
        this.showBlock('infoForm');
    }

    /**
     * Отобразить блок с загрузчиком
     */
    showLoader() {
        this.showBlock('loader');
    }

    /**
     * Отобразить блок с картой
     */
    showMap() {
        this.showBlock('map');
    }

    setLoading(value) {
        this.isLoading = !!value;
    }

    /**
     * Подтвердили ввод данных и они прошли валидацию
     */
    onInfoEntered() {
        const { loader, map, infoForm } = this.blocks;
        this.showLoader();
        loader.text = 'Идет загрузка карты';
        map.load().then(
            () => {
                const formData = infoForm.fullData;

                // Карта успешно загрузилась
                loader.text = 'Ищем ваш дом';
                map.addPointByData(formData).then(
                    () => {
                        // Точки из ответа обработаны и добавлены на карту
                        this.showMap(); // Удачно добавили точки
                    },
                    (message) => {
                        console.warn(message);
                        infoForm.houseError = message;
                        this.showInfoForm();
                    }
                );
            },
            () => {
                // Карта не загрузилась
                loader.text = 'Ошибка доступа к Яндекс картам.';
            }
        );
    }

    /**
     * Отправить данные на сохранение
     *
     * @param  {Object} data Данные для сохранения
     */
    save(data = {}) {
        if (this.isLoading) {
            return;
        }

        // Если нам пришла ссылка на продолжение работы (например регистрация)
        if (config.continueUrl) {
            router.loadLocation(config.continueUrl);
            return;
        }

        console.log(
            'Send request for save',
            Object.assign(data, CSRF.getByObject())
        );
        this.xhr = $.ajax({
            url: '/myobjects/create',
            data: Object.assign(data, CSRF.getByObject()),
            method: 'POST',
            dataType: 'json',
            beforeSend: () => {
                this.setLoading(true);
            },
            complete: () => {
                this.xhr = null;
            },
            success: (response = {}) => {
                if (response.status !== 'ok') {
                    const { infoForm } = this.blocks;

                    this.setLoading(false);
                    this.showInfoForm();
                    infoForm.displayError(
                        response.message || 'Неизвестная ошибка сервера'
                    );
                    return;
                }

                const res = response.response || {};
                const url = res.url;

                if (url) {
                    window.location = url;
                } else {
                    window.location = '/';
                }
            },
            error: (err) => {
                this.setLoading(false);
                console.error(err);
            },
        });
    }
}
